<template>
    <div class="ListingIcons">
        <div class="ListingIcons__Icon" v-for="(feature,index) of features" :key="index">
            <el-tooltip class="item" effect="dark" :content="language === 'english' ? feature.str_feature_name_en : feature.str_feature_name_jp" placement="bottom">
                <img :src="feature.image" :alt="language === 'english' ? feature.str_feature_name_en : feature.str_feature_name_jp">
            </el-tooltip>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    export default {
        name:'listing-icons',
        props: {
            property: Object
        },
        computed: {
            ...mapState({
                language: (state) => {
                    return state.general.language
                },
                features: (state) => {
                    return [...state.property.property.building.building_features, ...state.property.property.property_features]
                }
            })
        },
        created() {
        }
    }
</script>

<style lang="scss">
    .ListingIcons {
        display: inline-block;
        width: 100%;

        &__Icon {
            display: inline-block;
            margin-right: 2em;

            img {
                display: inline-block;
                width: 30px;
                height: 30px;
            }
        }
    }

    .el-tooltip__popper {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }
</style>



